// Este componente almacena estados globales
// para ser usados por los demas componentes 
// https://reactjs.org/docs/context.html 

import { createContext } from 'react';

const UserLoginContext = createContext();

export default UserLoginContext;